<template>
  <div class="home">
    <div class="headBox">
      <van-nav-bar
        title="单次拨打"
        fixed="true"
      />
    </div>
    <div id='call'>
      <h2 class='Block_title'>被通知人信息</h2> 
      <van-form @submit="onSubmit">
        <van-field 
          v-model="tel" 
          name="tel"
          type="tel" 
          label="手机号" 
          placeholder="手机号"
          :rules="phoneRules"
        />
        <van-field
          v-model="content"
          name="content"
          label="通知内容"
          type="textarea"
          rows="2"
          maxlength="100"
          show-word-limit
          placeholder="请输入通知内容"
          :rules="[{ required: true, message: '请填写通知内容' }]"
        />
        <h2 class='Block_title'>当接听人有疑问时的联系方式</h2> 
        <van-field
          v-model="myname"
          name="myname"
          label="联系人"
          placeholder="联系人"
          :rules="[{ required: true, message: '请填写联系人' }]"
        />
        <van-field 
          v-model="mytel" 
          name="mytel"
          type="tel" 
          label="手机号" 
          placeholder="手机号"
          :rules="phoneRules"
        />
        <div class='call_submit'>
          <van-button round block type="info" native-type="submit">
            拨打
          </van-button>
        </div>
      </van-form> 



    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { Button, Tab, Tabs, NavBar,Search,Toast,Dialog } from 'vant';
  import './styles/f_index.less';

  export default {
    name: 'home',
    components: {
      [Button.name]: Button,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [NavBar.name]: NavBar,
      [Search.name]:Search ,
      propsFootdata: [
        { title: '首页', img: [] }
      ]
    },
    data() {
      this.phoneRules = [
        { required: true, message: '请输入手机号' },
        { validator: this.phoneValidator, message: '手机号格式错误' },
      ];
      return {
        mytel: '',
        myname: '',
        tel: '',
        content: '',
      }
    },
    methods: {
      phoneValidator(val) {
        return /1\d{10}/.test(val);
      },
      onSubmit(values) {
        let toast = Toast.loading({
          //message: response.msg,
          forbidClick: true,
          duration: 10000,
          forbidClick: true,
        });

        let that = this;
        let params = {
          "text":  values.content,
          "called_phone": values.tel,
          "call_name": values.myname,
          "call_phone": values.mytel,
        }
        this.$post('api/v1/call/test/', params)
        .then((response) => {
            Toast.clear();
            if(response.code == 0){
                  Dialog.alert({
                    title: '提示',
                    message: response.msg
                  }).then(() => {
                    // on close
                  });

              //Dialog.alert({
              //  title: '提示',
              //  message: response.msg
              //}).then(() => {
              //  // on close
              //});
            }else{
              Dialog.alert({
                title: '提示',
                message: response.msg
              }).then(() => {
                // on close
              });
            }
        }) 


      },
    },
    created(){
        if(!window.sessionStorage.getItem('token')) {
          //this.$router.push({path:'/login'})
        }
    }
  }
</script>
<style scope>
html{
  height: 100%;
  background: #f7f8fa;
}
.Block_title{
  margin: 0;
  text-align:left;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 0.28rem;
  line-height: 16px;
}
.call_submit{
  position: absolute;
  bottom:1.3rem;
  width: 90%;
  margin: 16px;
}
#call{
  margin-top: 0.92rem;
}
</style>
